import api from './api';

const cortesPdfService = {
  // Processar PDF e extrair dados
  processPdf: async (file) => {
    try {
      const formData = new FormData();
      formData.append('pdf', file);
      
      const response = await api.post('/cortes-pdf/process', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Erro ao processar PDF:', error);
      throw error;
    }
  },

  // Listar PDFs processados
  listPdfProcessados: async (params = {}) => {
    try {
      const response = await api.get('/cortes-pdf', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar PDFs processados:', error);
      throw error;
    }
  },

  // Obter detalhes de um PDF
  getPdfDetalhes: async (id) => {
    try {
      const response = await api.get(`/cortes-pdf/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao obter detalhes do PDF:', error);
      throw error;
    }
  },

  // Deletar PDF processado
  deletePdfProcessado: async (id) => {
    try {
      const response = await api.delete(`/cortes-pdf/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar PDF:', error);
      throw error;
    }
  },
};

export default cortesPdfService;
